import type {ReactElement} from 'react';
import {useRef} from 'react';
import React from 'react';
import type {BaseItemShadowOptionsProps} from './base-item-shadow-options.types';
import {BaseItemShadowOptionsWeb} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-shadow-options-web';
import {BaseItemShadowOptionsMobile} from '@Panels/poster-editor-item-shadow-panel/components/base-item-shadow-options-mobile';
import type {ShadowOrGlowOptionsObject} from '@Utils/fabric-shadow.util';

export function BaseItemShadowOptions({isMobile = false, ...props}: BaseItemShadowOptionsProps): ReactElement<any> {
  const lastKnownAngleRef = useRef(45);

  const updateDistance = (dropShadowDistance: number, undoable = true): void => {
    if (!props.shadowOptions) {
      return;
    }

    if (dropShadowDistance !== 0 && props.shadowOptions.distance !== 0) {
      lastKnownAngleRef.current = props.shadowOptions.angle;
    }

    props.onUpdateDistance(dropShadowDistance, lastKnownAngleRef.current, undoable);
  };

  const updateAngle = (dropShadowAngle: number, undoable = true): void => {
    lastKnownAngleRef.current = dropShadowAngle;

    props.onUpdateAngle(dropShadowAngle, undoable);
  };

  const getShadowOrGlowOptions = (): ShadowOrGlowOptionsObject | null => {
    if (!props.shadowOptions) {
      return null;
    }

    if (props.shadowOptions.distance === 0) {
      return {
        ...props.shadowOptions,
        angle: lastKnownAngleRef.current,
      };
    }

    return props.shadowOptions;
  };

  const getBaseItemShadowOptions = (): ReactElement<any> => {
    if (isMobile) {
      if (!props.panelId) {
        throw new Error('With isMobile = true, BaseItemShadowOptionNew expects a panelId in the props');
      }

      return (
        <BaseItemShadowOptionsMobile
          panelId={props.panelId}
          shadowOptions={getShadowOrGlowOptions()}
          itemType={props.itemType}
          onToggleShadow={props.onToggleShadow}
          updateAngle={updateAngle}
          updateOpacity={props.onUpdateOpacity}
          updateDistance={updateDistance}
          updateBlur={props.onUpdateBlur}
          onClickColorOption={props.onClickColorFill}
          isForText={props.isForText}
          isForVector={props.isForVector}
        />
      );
    }

    return (
      <BaseItemShadowOptionsWeb
        shadowOptions={getShadowOrGlowOptions()}
        itemType={props.itemType}
        onClickColorFill={props.onClickColorFill}
        onToggleShadow={props.onToggleShadow}
        onUpdateOpacity={props.onUpdateOpacity}
        onUpdateAngle={updateAngle}
        onUpdateDistance={updateDistance}
        onUpdateBlur={props.onUpdateBlur}
      />
    );
  };

  return getBaseItemShadowOptions();
}
